import { CuadreIUbicacionProducto, ICuadreInventario } from "@/shared/interfaces/erp/inventario/cuadre-inventario.interface";
import { Checkbox, Chip } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo, } from "react";
import { calcColorCalculatorMaterialUI, cellNotFilter, emptyCellObject, formatDateWithTime } from "@/shared";
import { EstadoComponente } from "@/shared/components/ui";
import InfoUser from "@/shared/components/ui/InfoUser/InfoUser";

const formatearDuracionCuadre = (inicio?: string | null, fin?: string | null): string => {
  if (!inicio || !fin) return '-';
  const diffMs = new Date(fin).getTime() - new Date(inicio).getTime();
  if (isNaN(diffMs) || diffMs < 0) return '-';
  const totalMin = Math.floor(diffMs / 60000);
  const horas = Math.floor(totalMin / 60);
  const minutos = totalMin % 60;
  return `${horas} h ${String(minutos).padStart(2, '0')} min`;
};

export default function useTableColumnsCuadre() {


  const columns = useMemo<MRT_ColumnDef<ICuadreInventario>[]>(
    () => [
      {
        id: 'numero_referencia',
        accessorKey: 'numero_referencia',
        header: 'Num. Referencia',
      },
      {
        ...cellNotFilter,
        id: 'estado_cuadre',
        accessorKey: 'estado_cuadre',
        header: 'estado cuadre',
        Cell: ({ row }) => <Chip
          variant="outlined"
          color={calcColorCalculatorMaterialUI(row.original.estado_cuadre) as any}
          label={row.original.estado_cuadre} />
      },
      {
        id: 'bodega_nombre',
        accessorKey: 'bodega',
        header: 'bodega',
        Cell: ({ row }) => emptyCellObject(row.original.bodega_data, 'nombre')
      },
      {
        id: 'ubicacion_nombre',
        accessorKey: 'ubicacion',
        header: 'ubicacion',
        Cell: ({ row }) => emptyCellObject(row.original.ubicacion_data, 'nombre')

      },
      {
        ...cellNotFilter,
        id: 'fecha_creacion',
        accessorKey: 'fecha_creacion',
        header: 'fecha creacion',
        Cell: ({ row }) => `${formatDateWithTime(row.original.fecha_creacion)}`
      },
      {
        ...cellNotFilter,
        id: 'fecha_modificacion',
        accessorKey: 'fecha_modificacion',
        header: 'fecha modificacion',
        Cell: ({ row }) => `${formatDateWithTime(row.original.fecha_modificacion)}`
      },
      {
        ...cellNotFilter,
        id: 'fecha_hora_inicio',
        accessorKey: 'fecha_hora_inicio',
        header: 'inicio cuadre',
        Cell: ({ row }) => row.original.fecha_hora_inicio ? formatDateWithTime(row.original.fecha_hora_inicio) : '-'
      },
      {
        ...cellNotFilter,
        id: 'fecha_hora_fin',
        accessorKey: 'fecha_hora_fin',
        header: 'fin cuadre',
        Cell: ({ row }) => row.original.fecha_hora_fin ? formatDateWithTime(row.original.fecha_hora_fin) : '-'
      },
      {
        ...cellNotFilter,
        id: 'duracion',
        header: 'duracion',
        Cell: ({ row }) => formatearDuracionCuadre(row.original.fecha_hora_inicio, row.original.fecha_hora_fin)
      },
      {
        id: 'user_create',
        accessorKey: 'user_create',
        header: 'Usuario',
        Cell: ({ row }) => (
          <InfoUser user={row?.original?.user_create!} />
        )
      },
    ],
    []
  );


  const columnsCuadreTecnico = useMemo<MRT_ColumnDef<CuadreIUbicacionProducto>[]>(
    () => [
      {
        id: 'fecha_creacion',
        accessorKey: 'fecha_creacion',
        header: 'fecha creacion',
        Cell: ({ row }) => `${formatDateWithTime(row.original.fecha_creacion)}`

      },
      {
        id: '# Referencia',
        accessorKey: 'numero_referencia',
        header: '# Referencia',
      },
      {
        id: 'bodega',
        accessorKey: 'bodega',
        header: 'bodega',
      },
      {
        id: 'ubicacion',
        accessorKey: 'ubicacion_nombre',
        header: 'ubicacion',
      },
      {
        id: 'estado',
        accessorKey: 'estado_cuadre',
        header: 'estado',
      },
    ],
    []
  );


  const columnViewCuadreTecnico = useMemo<MRT_ColumnDef<CuadreIUbicacionProducto>[]>(
    () => [
      {
        accessorKey: 'accion',
        header: 'Accion',
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return <Checkbox
            value={row.original.check ?? false}
            inputProps={{ 'aria-label': 'controlled' }}
            checked={row.original.check ?? false}
            disabled={true}
          />
        }
      },
      {
        id: 'codigo',
        accessorKey: 'codigo',
        header: 'codigo',
      },
      {
        id: 'descripcion',
        accessorKey: 'descripcion',
        header: 'descripcion',
        size: 300
      },
      {
        id: 'stock',
        accessorKey: 'stock',
        header: 'stock',
      },
      {
        id: 'cantidad',
        accessorKey: 'cantidad',
        header: 'cantidad',

      },

      {
        id: 'diferencia',
        accessorKey: 'diferencia',
        header: 'diferencia',
        Cell: ({ row }) => row.original.diferencia ?? 0
      },
      {
        id: 'unidad_medida',
        accessorKey: 'unidad_medida',
        header: 'Unidad Medida',
      },
      {
        id: 'modelo_producto',
        accessorKey: 'modelo_producto',
        header: 'Modelo Producto',
      },
      {
        id: 'bodega',
        accessorKey: 'bodega',
        header: 'Bodega',
      },
      {
        id: 'ubicacion',
        accessorKey: 'ubicacion_nombre',
        header: 'Ubicación',
      },


      {
        id: 'observacion',
        accessorKey: 'observacion',
        header: 'Observación',

      },

    ],
    []
  );



  const columnsSeriesMateriales = useMemo<MRT_ColumnDef<{ series: string }>[]>(
    () => [
      {
        header: "#", // encabezado de la columna
        Cell: ({ row }) => row?.index + 1, // row.index empieza en 0
        size: 40,
      },
      {
        accessorKey: 'series',
        header: 'Serie'
      }
    ], []
  )

  return {
    columns,
    columnsCuadreTecnico,
    columnViewCuadreTecnico,
    columnsSeriesMateriales
  }

}